module.exports = __webpack_public_path__ + "themes/mf/img/scratch-cover@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/scratch-cover@2x.png
// module id = 109
// module chunks = 3